
import { DrawerProps } from '@mui/material';
import { useEffect, useState } from 'react';
import AnimatedEntrance from '@/views/common/AnimatedEntrance';
import ClosableDrawer from '@/features/shared/ClosableDrawer/ClosableDrawer';
import { SupportPanelHome } from './support-panel-home/SupportPanelHome';
import { SupportPanelReportProblem } from './support-panel-report-problem/SupportPanelReportProblem';
import { SupportPanelSuggestions } from './support-panel-suggestions/SupportPanelSuggestions';
import { SupportPanelSuggestionSent } from './support-panel-suggestions/SupportPanelSuggestionSent';

type PageState = 'home' | 'report' | 'suggestions' | 'suggestion-sent';
type SupportPanelDrawerProps = DrawerProps;

export const SupportPanelDrawer = (props: SupportPanelDrawerProps) => {
  const [pageState, setPageState] = useState<PageState>('home');

  useEffect(() => {
    if (!props.open) {
      setPageState('home');
    }
  }, [props.open]);

  return (
    <ClosableDrawer
      {...props as any}
    >
      {pageState === 'home' && (
        <AnimatedEntrance direction="left">
          <SupportPanelHome
            onReportProblem={() => setPageState('report')}
            onSuggestions={() => setPageState('suggestions')}
          />
        </AnimatedEntrance>
      )}
      {pageState === 'report' && (
        <AnimatedEntrance direction="left">
          <SupportPanelReportProblem onBack={() => setPageState('home')} />
        </AnimatedEntrance>
      )}
      {pageState === 'suggestions' && (
        <AnimatedEntrance
          direction="left"
          sx={{
            height: '100%',
          }}
        >
          <SupportPanelSuggestions
            onBack={() => setPageState('home')}
            onSuccess={() => setPageState('suggestion-sent')}
          />
        </AnimatedEntrance>
      )}
      {pageState === 'suggestion-sent' && (
        <AnimatedEntrance
          direction="left"
          sx={{
            height: '100%',
          }}
        >
          <SupportPanelSuggestionSent onClose={props.onClose as any} />
        </AnimatedEntrance>
      )}
    </ClosableDrawer>
  );
};
